import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import TimeFieldSimple from 'react-simple-timefield';

import { AppState } from 'models/app-store';
import { TimeRange } from 'utils/time';

import classes from './DatePickerFooter.module.scss';
import classNames from 'classnames';

type Props = {
  range: TimeRange | undefined;
  overLimit?: number | null;
  onChangeFrom: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeTo: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const DatePickerFooterView = (props: React.PropsWithChildren<Props>): JSX.Element => {
  const { t } = useTranslation();

  const darkMode = useSelector((state: AppState) => state.ui.darkMode);

  const customStyle: React.CSSProperties = {
    color: 'rgba(255, 255, 255, 0.87)',
    height: '30px',
    width: '50px',
    borderRadius: '8px',
    border: '1px solid #e3e7ea',
    textAlign: 'center',
    outline: 'none',
    backgroundColor: 'transparent',
    ...(!darkMode && {
      color: '#5c6873',
      outline: 'none',
    }),
  };

  return (
    <div className={classNames(classes['container'], { [classes['container--overLimit']]: props.overLimit })}>
      <div>
        <p className={classes['title']}>{t('filters.filterDate.fromTime')}</p>
        <TimeFieldSimple style={customStyle} value={props.range?.from} onChange={props.onChangeFrom}></TimeFieldSimple>
      </div>
      <div>
        <p className={classes['title']}>{t('filters.filterDate.toTime')}</p>
        <TimeFieldSimple style={customStyle} value={props.range?.to} onChange={props.onChangeTo}></TimeFieldSimple>
      </div>
    </div>
  );
};

DatePickerFooterView.displayName = 'DatePickerFooterView';

export default DatePickerFooterView;
